<template>
  <section class="input-panel">
    <h2 class="panel-title">场景描述</h2>
    <p class="input-tip">描述设备、连接和当前状态，从文字构建可演化的 3D 场景。已有场景可以从场景库直接载入。</p>

    <!-- 拓扑类型参数已不需要，仅保留描述输入 -->
    <!-- <div class="form-group">
      <label>拓扑类型</label>
      <div class="type-options">
        <label
          v-for="opt in types"
          :key="opt.value"
          class="type-option"
          :class="{ active: type === opt.value }"
        >
          <input type="radio" v-model="type" :value="opt.value" />
          <span>{{ opt.label }}</span>
        </label>
      </div>
    </div> -->

    <div class="form-group grow">
      <label>描述</label>
      <textarea
        v-model="text"
        :disabled="loading"
        class="desc-textarea"
        rows="18"
        placeholder="请输入对该场景的自然语言描述，或从场景库载入已有描述。例如：一个由 4 架无人机和 1 个地面站构成的编队系统..."
      ></textarea>
    </div>

    <button class="generate-btn" :disabled="loading" @click="onGenerate">
      {{ loading ? '生成中...' : '生成场景' }}
    </button>
  </section>
</template>

<script>
import { TOPOLOGY_TYPES } from '../api/topology'

export default {
  name: 'TopologyInput',
  props: {
    loading: { type: Boolean, default: false },
    description: { type: String, default: '' },
    presetScene: { type: Object, default: null }
  },
  emits: ['generate', 'description-change'],
  data() {
    return {
      text: '',
      type: 'communication',
      types: TOPOLOGY_TYPES
    }
  },
  watch: {
    text(value) { this.$emit('description-change', value) },
    description: { immediate: true, handler(value) { this.text = value } },
    presetScene: {
      immediate: true,
      handler(preset) {
        this.type = preset?.topology_type || 'communication'
      }
    }
  },
  methods: {
    onGenerate() {
      this.$emit('generate', { text: this.text, type: this.type })
    }
  }
}
</script>

<style scoped>
.input-panel {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: #fff;
  border-right: 1px solid #eaeaea;
  width: 360px;
  box-sizing: border-box;
}
.panel-title {
  margin: 0 0 16px;
  font-size: 18px;
  color: #1f1f1f;
}
.form-group {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}
.form-group.grow {
  flex: 1;
  min-height: 0;
}
.desc-textarea {
  flex: 1;
  min-height: 340px;
}
.form-group > label {
  font-size: 13px;
  color: #595959;
  margin-bottom: 8px;
}
.type-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.type-option {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s;
}
.type-option input {
  margin-right: 6px;
}
.type-option.active {
  border-color: #1890ff;
  background: #e6f7ff;
  color: #1890ff;
}
.preset-row {
  display: flex;
  gap: 8px;
}
.preset-select {
  flex: 1;
  min-width: 0;
  padding: 8px;
  font-size: 13px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
}
.preset-select:focus {
  outline: none;
  border-color: #1890ff;
}
textarea {
  resize: vertical;
  padding: 8px;
  font-size: 13px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  font-family: inherit;
}
textarea:focus {
  outline: none;
  border-color: #1890ff;
}
.generate-btn {
  margin-top: auto;
  padding: 10px 16px;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}
.generate-btn:hover:not(:disabled) {
  background: #40a9ff;
}
.generate-btn:disabled {
  background: #bfbfbf;
  cursor: not-allowed;
}
</style>


